import React, { useState } from 'react';
import { TabContainer } from '../styles';

export const AssetTabView = ({ assetTabs, currentTab, showMinimal, handleCurrentTabChange }) => {
  const [activeTab, setActiveTab] = useState(currentTab || assetTabs[0].title);

  const onTabChange = key => {
    const tab = assetTabs.find(tab => tab.title === key);
    if (tab) {
      setActiveTab(tab.title);
      handleCurrentTabChange(tab.title);
    }
  };

  const items = assetTabs.map(tab => ({
    key: tab.title,
    label: tab.title,
  }));

  return <TabContainer items={items} onChange={onTabChange} activeKey={activeTab} />;
};
